<template>
    <div class="lam-request-for-material-picker">
        <div class="uk-grid uk-grid-small uk-grid-width-1-3">
            <div
                v-for="type in request_types"
                :key="type.id"
            >
                <form-checkbox
                    :id="`request-type-${type.id}`"
                    :value="record.requests_for_material.indexOf(type.id)>=0"
                    :name="`${type.id}`"
                    :editable="true"
                    @input="toggle_request_for_material"
                >
                    {{ type.name }}
                </form-checkbox>
            </div>
        </div>

        <div class="uk-grid uk-grid-small" data-uk-grid-margin>
            <div class="uk-width-2-10 lam-label-column">
                <div class="uk-form-controls-text">Received On</div>
            </div>
            <div class="uk-width-3-10">
                <form-date-input
                    id="new_rfms_requested_at"
                    v-model="record.requested_at"
                    :max-date="0"
                    name="requested_at"
                    :editable="true"
                    :required="false"
                />
            </div>
            <div class="uk-width-2-10 lam-label-column">
                <div class="uk-form-controls-text">Due On</div>
            </div>
            <div class="uk-width-3-10">
                <form-date-input
                    id="new_rfms_due_at"
                    v-model="record.due_at"
                    name="due_at"
                    :editable="true"
                    :required="false"
                />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import { orderBy } from "lodash"

import profile_utilities from "../mixins/ProfileUtilities"
import string_utilities from "../mixins/StringUtilities"

import FormDateInput from "./FormDateInput"
import FormCheckbox from "./FormCheckbox"

export default {
    mixins: [profile_utilities, string_utilities],
    components: {
        FormDateInput,
        FormCheckbox
    },
    methods: {
        toggle_request_for_material (checked, request_type) {
            request_type = parseInt(request_type) || 0
            // if(!request_type) return // "0" is valid == fake RFM for "add'l services"
            const index = this.record.requests_for_material.indexOf(request_type)
            if(checked && (index < 0)) this.record.requests_for_material.push(request_type)
            else if(!checked && (index >= 0)) this.record.requests_for_material.splice(index, 1)
        }
    },
    computed: {
        request_types () {
            let request_types = this.dictionary("request_for_material")
            if(this.withoutProposal) request_types = request_types.filter(request_type => request_type.code_constant !== "proposal")
            if(this.withServices) {
                request_types = request_types.filter(request_type => !request_type.parent_id)
                request_types.push({
                    id: 0,
                    code_constant: "service_request",
                    name: "Additional Services",
                    label: "Additional Services"
                })
                if(!this.is_db_admin_active && !this.is_business_manager) request_types = request_types.filter(request_type => request_type.code_constant && request_type.code_constant.match(/^(service_request|contract|proposal)$/i))
            }
            return orderBy(request_types, [term => {
                if(term.name.match(/^other$/i)) return "zzzzzOther"
                return term.name
            }], "asc")
        }
    },
    props: {
        record: {
            type: Object,
            required: true
        },
        withoutProposal: {
            type: Boolean,
            default: false
        },
        withServices: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            // input_format: "MM-DD-YYYY",
        }
    }
    /*
    mounted () {
        UIkit.datepicker(this.$refs.requested_at, {offsettop: 0, maxDate: 0, format: this.input_format}).on("hide.uk.datepicker", () => {
            const input_value = this.input_value(this.$refs.requested_at.value)
            if(input_value !== this.record.requested_at) this.record.requested_at = input_value
        })
        UIkit.datepicker(this.$refs.due_at, {offsettop: 0, format: this.input_format}).on("hide.uk.datepicker", () => {
            const input_value = this.input_value(this.$refs.due_at.value)
            if(input_value !== this.record.due_at) this.record.due_at = input_value
        })
    },
    methods: {
        input_value (value) {
            if(this.input_format === "MM-DD-YYYY") return value.replace(/^(\d{1,2})\-(\d{1,2})\-(\d{2,4})/, "$3-$1-$2")
            return value
        }
    },
    computed: {
        requested_at_value: {
            get () {
                if(!this.record || !this.record.requested_at) return ""
                return this.$moment(this.record.requested_at).format(this.input_format)
            },
            set (value) {
                if(this.record) this.record.requested_at = value
            }
        },
        due_at_value: {
            get () {
                if(!this.record || !this.record.due_at) return ""
                return this.$moment(this.record.due_at).format(this.input_format)
            },
            set (value) {
                if(this.record) this.record.due_at = value
            }
        },
    },
    */
}
</script>
